import { render, staticRenderFns } from "./BugButton.vue?vue&type=template&id=00799d8a&scoped=true"
import script from "./BugButton.vue?vue&type=script&lang=js"
export * from "./BugButton.vue?vue&type=script&lang=js"
import style0 from "./BugButton.vue?vue&type=style&index=0&id=00799d8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00799d8a",
  null
  
)

export default component.exports